import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div data-testid="auth-loading" className="font-heading font-black text-2xl uppercase tracking-tight">
                    Loading...
                </div>
            </div>
        );
    }
    if (!user || user === false) {
        return <Navigate to="/login" replace />;
    }
    return children;
}
